// extracted by mini-css-extract-plugin
export var personalizationAttendeeContainer = "Tabs-module--personalization-attendee-container--54366";
export var personalizationOrganizerContainer = "Tabs-module--personalization-organizer-container--d9e67";